/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
	ApiRequestOptions,
	ApiResponseDefault,
	ApiService,
	ApiServiceConfig,
	HttpMethod,
} from '@ipb-genesis/ipb-services';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { setVariables } from 'apps/ipb-backoffice/src/app/data/api.routes';
import {
	IUnits,
	RolesAsigned,
} from '../../../../interfaces';
import { getEnv } from '../../../../utils/Utils';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class InternalUsersService {
	public constructor(private apiService: ApiService, http: HttpClient) {
		this.apiService.setConfig({ http, baseUrl: getEnv().boRegisterBff } as ApiServiceConfig
		);
	}

	public getUnits(): Observable<ApiResponseDefault<IUnits[]>> {
		const apiReqOptions: ApiRequestOptions = {
			method: HttpMethod.GET,
			customUrl: getEnv().boRegisterBff,
			path: getEnv().apiRoutes.internalUserUnits,
			shouldCancelPrevious: false,
		};
		return this.apiService.request<ApiResponseDefault<IUnits[]>>(apiReqOptions);
	}

	public getRolesAsigned(userId?: number): Observable<ApiResponseDefault<RolesAsigned>> {
		const apiReqOptions: ApiRequestOptions = {
			method: HttpMethod.GET,
			customUrl: getEnv().boRegisterBff,
			path: setVariables(getEnv().apiRoutes.authorizationRolesForUser, [userId]),
		};
		return this.apiService.request<ApiResponseDefault<RolesAsigned>>(apiReqOptions);
	}
}
